/* PPF-Kits Handymenü (User 25.10.2026), Markup: snippets/header-drawer.liquid, Optik: assets/pk-menu-drawer.css
   - Unterpunkte klappen an Ort und Stelle auf (Akkordeon). Dawns MenuDrawer (assets/global.js) würde sie als eigene Seite
     hereinschieben: der Klick auf die Überschrift wird deshalb in der Capture-Phase abgefangen, bevor Dawns Listener ihn sieht.
     Schließen des ganzen Menüs, Escape und Fokusfalle bleiben bei Dawn (closeMenuDrawer entfernt alle open-Attribute).
   - "Wähle dein Auto" schließt das Menü und überlässt den Rest assets/ppf-ymm.js (#ymm-Links öffnen dort Popup, Karte
     oder Leiste). Gibt es auf der Seite keine Fahrzeugsuche, geht es zur Startseite. */
(function () {
  'use strict';
  if (window.__pkMenuDrawer) return;
  window.__pkMenuDrawer = true;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EASE = 'cubic-bezier(.2, 0, 0, 1)';

  function drawer() { return document.querySelector('header-drawer'); }
  function ymmTarget() { return document.querySelector('[data-ppf-ymm]') || document.querySelector('#MainContent .easysearch-block-container'); }
  function panelOf(d) { return d.querySelector(':scope > .menu-drawer__submenu'); }

  // Zustand = natives open-Attribut (Dawns closeMenuDrawer entfernt es beim Schließen des Menüs); .pk-mnav-closing nur während der Animation
  function isOpen(d) { return d.hasAttribute('open') && !d.classList.contains('pk-mnav-closing'); }
  function open(d) {
    var sum = d.querySelector(':scope > summary'), panel = panelOf(d);
    d.classList.remove('pk-mnav-closing');
    d.setAttribute('open', '');
    sum.setAttribute('aria-expanded', 'true');
    if (!RM.matches && panel && panel.animate) {
      panel.getAnimations().forEach(function (x) { x.cancel(); });
      panel.animate([{ height: '0px', opacity: 0 }, { height: panel.scrollHeight + 'px', opacity: 1 }], { duration: 280, easing: EASE });
    }
    reveal(d);
  }
  // Aufgeklappter Bereich soll ganz sichtbar sein (User 24.10.2026): das Menü scrollt mit, bis die letzte Option zu sehen ist,
  // aber nie so weit, dass die Überschrift oben verschwindet. Gerechnet mit der Endhöhe, damit es parallel zum Aufklappen läuft.
  function reveal(d) {
    var box = d.closest('.menu-drawer__navigation-container'), panel = panelOf(d), sum = d.querySelector(':scope > summary');
    if (!box || !panel || !sum) return;
    var b = box.getBoundingClientRect(), st = sum.getBoundingClientRect();
    var bottom = st.bottom + panel.scrollHeight + 28;      // Unterkante nach dem Aufklappen (+ Luft)
    var over = bottom - b.bottom;
    if (over <= 0) return;
    var maxUp = st.top - b.top - 8;                        // Überschrift bleibt oben stehen
    box.scrollBy({ top: Math.min(over, Math.max(0, maxUp)), behavior: RM.matches ? 'auto' : 'smooth' });
  }
  function close(d) {
    var sum = d.querySelector(':scope > summary'), panel = panelOf(d);
    sum.setAttribute('aria-expanded', 'false');
    if (RM.matches || !panel || !panel.animate) { d.removeAttribute('open'); return; }
    d.classList.add('pk-mnav-closing');
    var a = panel.animate([{ height: panel.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 220, easing: EASE });
    a.onfinish = function () { if (d.classList.contains('pk-mnav-closing')) { d.classList.remove('pk-mnav-closing'); d.removeAttribute('open'); } };
  }

  // Dawn misst beim Öffnen die Unterkante der Kopfzeile (--header-bottom-position). Ist die sticky Kopfzeile nach dem
  // Runterscrollen gerade noch eingefahren, kommt -1 px heraus und das Menü wird zu hoch (Konto, Land, Sprache abgeschnitten).
  function fixHeaderBottom() {
    var h = document.querySelector('.section-header');
    if (!h) return;
    var b = h.getBoundingClientRect().bottom;
    var v = b > h.offsetHeight / 2 ? b : h.offsetHeight;
    document.documentElement.style.setProperty('--header-bottom-position', Math.round(v) + 'px');
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('header-drawer > details > summary');
    if (!s) return;
    [30, 260, 520].forEach(function (t) { setTimeout(fixHeaderBottom, t); });
  });

  // Capture auf window: läuft vor Dawns Listenern an jedem <summary> und vor dem #ymm-Capture von ppf-ymm.js (document)
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var sum = t.closest('.pk-mnav .menu-drawer__menu summary');
    if (sum) {
      var d = sum.parentNode;
      e.preventDefault();
      e.stopPropagation();
      if (isOpen(d)) { close(d); return; }
      // nur ein Bereich offen: Geschwister schließen
      var list = d.closest('ul');
      if (list) list.querySelectorAll(':scope > li > details[open]').forEach(function (x) { if (x !== d && isOpen(x)) close(x); });
      open(d);
      return;
    }
    var find = t.closest('[data-pk-mnav-find]');
    if (find) {
      var hd = drawer();
      if (hd && typeof hd.closeMenuDrawer === 'function') {
        var msum = hd.querySelector('summary');
        hd.closeMenuDrawer(e, msum);
        var main = hd.querySelector('details');
        if (main) main.removeAttribute('open');
        // Dawn setzt aria-expanded nur beim Klick auf den Menü-Knopf zurück (global.js); solange es "true" ist, malt
        // base.css den grauen Schleier (.header__icon--menu[aria-expanded='true']::before) über die Seite
        if (msum) msum.setAttribute('aria-expanded', 'false');
      }
      // keine Fahrzeugsuche auf dieser Seite: zur Startseite, dort öffnet #ymm die Suche
      // (die App baut ihr Widget verzögert auf, daher auch auf den Container prüfen, nicht nur auf [data-ppf-ymm])
      if (!ymmTarget() && !document.querySelector('[data-ppf-ymm-open]')) {
        e.preventDefault();
        location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + '#ymm';
        return;
      }
      // Suche auf der Seite: nie neu laden (der Link hat keinen Query-String wie ?variant=, der Browser würde sonst navigieren).
      // ppf-ymm.js sieht den Klick trotzdem (Capture auf document) und öffnet Popup, Karte oder Leiste.
      e.preventDefault();
      // Karte oder Leiste (kein Popup): nach dem Schließen hinscrollen
      setTimeout(function () {
        if (document.querySelector('dialog[open]')) return;
        var slot = ymmTarget();
        if (slot) slot.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'center' });
      }, 120);
    }
  }, true);

  // Tastatur: Enter/Leertaste auf <summary> lösen einen click aus, Escape regelt Dawn
})();
